/* eslint-disable */
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    '&:focus': {
      outline: 'none'
    }
  },
  formControl: {
    width: '100%',
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      top: 0,
      border: '1px solid #FF8C69',
      borderRadius: 0
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline legend': {
      display: 'none'
    },
    '& .MuiInputLabel-root': {
      fontSize: 16,
      color: 'rgba(0, 0, 0, 0.54) !important',
      transform: 'translate(14px, 18px) scale(1) !important',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        transform: 'translate(14px, 19px) scale(1) !important'
      }
    },
    '.rtl & .MuiInputLabel-root': {
      left: 'auto',
      right: 0,
      transformOrigin: 'top right',
      transform: 'translate(-14px, 18px) scale(1) !important',
      [theme.breakpoints.down('sm')]: {
        transform: 'translate(-14px, 19px) scale(1) !important'
      }
    }
  },
  list: {
    overflowY: 'auto',
    maxHeight: 320
  },
  select: {
    backgroundColor: '#ff8c691a',
    '& .MuiOutlinedInput-input': {
      padding: 15,
      paddingRight: 32,
      fontSize: 16,
      [theme.breakpoints.down('sm')]: {
        fontSize: 14
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #FF8C69',
      borderRadius: 0
    },
    '.rtl & .MuiOutlinedInput-input': {
      paddingRight: 15,
      paddingLeft: 32
    },
    '.rtl & svg': {
      right: 'auto',
      left: 7
    }
  },
  listItem: {
    minHeight: 34
  }
}));
